module.exports = __webpack_public_path__ + "img/영등포 맛집.1d6b7683.png";